import React, { useState } from "react";
import commonService from "../../services/otherServices";

interface EditableListNameProps {
    projectId: string;
    initialName: string;
    numberOfContacts: number;
    onSuccess?: (newName: string) => void;
}

const EditableListName: React.FC<EditableListNameProps> = ({
    projectId,
    initialName,
    numberOfContacts,
    onSuccess,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(initialName);
    const [originalValue, setOriginalValue] = useState(initialName);
    const [loading, setLoading] = useState(false);

    const handleEdit = () => {
        setOriginalValue(value);
        setIsEditing(true);
    };

    const handleCancel = () => {
        setValue(originalValue);
        setIsEditing(false);
    };

    const handleSave = async () => {
        if (!value.trim()) {
            alert("List name cannot be empty");
            return;
        }

        try {
            setLoading(true);
            const payload = {
                list_name: value,
                projectid: projectId
            };
            const response = await commonService.update_list(payload);
            onSuccess?.(value);
            setIsEditing(false);
        } catch (err) {
            console.error(err);
            setValue(originalValue);
            alert("Failed to update list name");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                // width: "220px",
                // display: "flex",
                // justifyContent: "start",
            }}
        >
            {/* DISPLAY MODE */}
            {!isEditing && (
                <div
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        maxWidth: "200px",
                        overflow: "hidden",
                    }}
                >
                    <span
                        title={value || `File_${numberOfContacts}`}
                        style={{
                            maxWidth: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            textAlign: "center",
                        }}
                    >
                        {value || `File_${numberOfContacts}`}
                    </span>

                    <i
                        className="fas fa-pencil-alt"
                        onClick={handleEdit}
                        title="Edit"
                        style={{
                            fontSize: "7px",
                            cursor: "pointer",
                            color: "#115ea3",
                            flexShrink: 0,
                            position: "relative",
                            top: "-5px",
                        }}
                    />
                </div>
            )}

            {/* EDIT MODE */}
            {isEditing && (
                <div
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        maxWidth: "200px",
                    }}
                >
                    <input
                        className="form-control form-control-sm"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        style={{
                            width: "120px",
                            textAlign: "center",
                            fontSize: "12px"
                        }}
                        autoFocus
                    />

                    <i
                        className="fas fa-check"
                        onClick={handleSave}
                        title="Save"
                        style={{
                            color: "green",
                            cursor: "pointer",
                            fontSize: "12px",
                        }}
                    />

                    <i
                        className="fas fa-times"
                        onClick={handleCancel}
                        title="Cancel"
                        style={{
                            color: "red",
                            cursor: "pointer",
                            fontSize: "12px",
                        }}
                    />
                </div>
            )}
        </div>
    );


};

export default EditableListName;
